import "uppy/dist/uppy.min.css";
import {Uppy, Dashboard, AwsS3} from "uppy";
import Japanese from "@uppy/locales/lib/ja_JP";
import Plyr from "plyr";

function videoUpload() {
  const uploadByUppy = (fileInput) => {
    const uploadBtn = document.querySelector(".js-video-upload-btn");
    const hiddenInput = document.querySelector(".js-video-hidden-field");
    const videoUploadMessage = document.querySelector(".js-video-upload-message");
    const videoUploadFileName = document.querySelector(".js-video-upload-file-name");
    const videoPreview = document.querySelector(".js-video-preview");

    // 「ファイルを選択」は表示しない
    fileInput.remove();

    const uppy = new Uppy({
      id: fileInput.id,
      autoProceed: true,
      restrictions: {
        allowedFileTypes: fileInput.accept.split(","),
        maxNumberOfFiles: 1,
        minNumberOfFiles: 1,
      },
      locale: Japanese
    })
      .use(Dashboard, {
        trigger: uploadBtn,
        closeModalOnClickOutside: true,
        closeAfterFinish: true
      })
      .use(AwsS3, {
        companionUrl: '/video', // routesでmountしたShrine.presign_endpointの `/video/s3/params` にアクセスされる
      });
    uppy.on("upload-success", (file, response) => {
      // メッセージを表示
      videoUploadMessage.classList.remove("d-none");
      videoUploadFileName.innerText = file.name;

      // preview
      videoPreview.src = URL.createObjectURL(file.data);
      videoPreview.classList.remove("d-none");
      new Plyr(".js-video-preview");

      const cacheFilePattern = new RegExp("^video_cache\/(.+)");
      const uploadedFileData = {
        id: file.meta["key"].match(cacheFilePattern)[1], // ff5bbcbf08f764797d84900ea7b0b765.mov のような値が入る
        storage: "video_cache",
        metadata: {
          size: file.size,
          filename: file.name,
          mime_type: file.type,
        },
      };

      hiddenInput.value = JSON.stringify(uploadedFileData);
    });
  }

  document.querySelectorAll('.js-video-file-field').forEach(fileInput => {
    uploadByUppy(fileInput);
  });
}

export default () => {
  videoUpload();
}
